import React, { Component } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { ButtonToolbar } from 'react-bootstrap'
import '../menuIcon.css'
//import InputRange from 'react-input-range';
import "react-input-range/lib/css/index.css";
import { getFilterOptions } from '../UserFunctions'
//import { Link } from 'react-router-dom'
//import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
//import VirtualizedSelect from 'react-virtualized-select'
import PropTypes from 'prop-types';

class AdvanceSearchModalCloseLoopRevised extends Component {
    constructor(props) {
        super(props);
        this.formRef = React.createRef()
        this.state = {
            bench_list_res: [],
            status_list_res: [],
            video_list_res: [],
            run_id_res: [],
            version_id_res: [],
            bench_list_selected: [],
            result_list_selected: [],
            video_status_list_selected: [],
            run_id_selected: [],
            version_id_selected: [],
            bench_name_selected:[],
            cad_id_selected:[],
            status_selected:[],
            runIdNullFilterChecked:true,
            status_list: [
                { id: "Pass", value: "Pass", isChecked: false },
                { id: "Fail", value: "Fail", isChecked: false }
            ],
            pass: false,
            fail: false,
            startDate: new Date(),
            run_id: ["1", "2"],
            version_id: ["1", "2"]
            
        };
    };
    reset = () => {
        this.formRef.current.reset()
      }
    handleChange = date => {
        this.setState({
            startDate: date
        });
    };

    toggleRunIdNullFilter = () => {
        this.setState({
            runIdNullFilterChecked:!this.state.runIdNullFilterChecked
        })
    }


    onRunIdChangeHandler = (event) => {
        this.setState({
            run_id_selected: [event.target.value]
        })
    }

    onVersionIdChangeHandler = (event) => {
        this.setState({
            version_id_selected: [event.target.value]
        })
    }
    onBenchChangeHandler = (event) => {
        this.setState({
            bench_name_selected: [event.target.value]

        })
    }
    OnCadIdChangeHandler = (event) => {
        this.setState({
            cad_id_selected: [event.target.value]

        })

    }
    onStatusChangeHandler = (event) => {
        this.setState({
            status_selected: [event.target.value]
        })
    }

    onChangeBench = (bench) => {
        if (this.state.bench_list_selected.includes(bench)) {
            this.setState({
                bench_list_selected: this.state.bench_list_selected.filter((element) => element !== bench)
            })
        }
        else {
            this.setState({
                bench_list_selected: [...this.state.bench_list_selected, bench]
            })
        }
    }

    onResultChange = (result) => {
        if (this.state.result_list_selected.includes(result)) {
            this.setState({
                result_list_selected: this.state.result_list_selected.filter((element => element !== result))
            })
        } else {
            this.setState({
                result_list_selected: [...this.state.result_list_selected, result]
            })
        }
    }

    onVideoStatusChange = (status) => {
        if (this.state.video_status_list_selected.includes(status)) {
            this.setState({
                video_status_list_selected: this.state.video_status_list_selected.filter((element => element !== status))
            })
        } else {
            this.setState({
                video_status_list_selected: [...this.state.video_status_list_selected, status]
            })
        }
    }


    onSearchFilter(e) {
        this.props.onSearchClick(this.state.run_id_selected, this.state.version_id_selected,this.state.bench_name_selected,this.state.cad_id_selected,this.state.status_selected, this.state.runIdNullFilterChecked)
    };
    onResetFilter = (e) => {
        document.getElementById('runid').value = null
        document.getElementById('versionid').value = null
        document.getElementById('benchname').value = null
        document.getElementById('cadid').value = null
        document.getElementById('statusid').value = null
        this.setState({
            run_id_selected : "",
            version_id_selected : "",
            bench_name_selected : "",
            cad_id_selected : "",
            status_selected : "",
        })
        
    };

    componentDidMount() {
        getFilterOptions().then(response => {
            

            this.setState({
                bench_list_res: response.data.bench_list,
                status_list_res: response.data.status,
                video_list_res: response.data.video_status,
            })

        })
    }

    render() {
        return (
            <div data-test = 'closedLoopAdvanceSearchModalCloseLoopRevisedComponent'>
                <Modal size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    isOpen={true}>
                    <ModalHeader
                        toggle={this.props.closeSearchModal}
                        style={{ fontWeight: "bold", color: "#524fa1" }}
                    >
                        Advance Search
                    </ModalHeader>
                    <ModalBody>
                        <div className="container">
                            <div className="row">
                                <div className="col-md-6" style={{ display: "inline-block" }}>
                                   

                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12" style={{ border: "1px solid #858AFF", backgroundColor: "#757AF7" }}>
                                   
                                   <form>
                                    <div style={{ width: "13rem", padding: "5px", display: "inline-block" }}>
                                        <div style={{ float: "left", padding: "5px", display: "inline-block", color: "#FFFFFF", fontWeight: "bold" }}>
                                            Run Id :
                                            </div>
                                        <div style={{ float: "left", padding: "5px", width: "4rem", display: "inline-block" }}>
                                           
                                            <input type="text" id = "runid" placeholder=" Run Id " style={{ width: "6rem" }} onChange={(e) => this.onRunIdChangeHandler(e)} />
                                        </div>
                                    </div>
                                    <div style={{ width: "14rem", padding: "5px", display: "inline-block" }}>
                                        <div style={{ float: "left", padding: "5px", display: "inline-block", color: "#FFFFFF", fontWeight: "bold" }}>
                                            Version Id :
                                            </div>
                                        <div style={{ float: "left", padding: "5px", width: "4rem", display: "inline-block" }}>
                                           
                                            <input type="text" id = "versionid" placeholder=" Version Id " style={{ width: "6rem" }} onChange={(e) => this.onVersionIdChangeHandler(e)}/>
                                        </div>
                                    </div>
                                    <div style={{ width: "14rem", padding: "5px", display: "inline-block" }}>
                                        <div style={{ float: "left", padding: "5px", display: "inline-block", color: "#FFFFFF", fontWeight: "bold" }}>
                                            Bench Name :
                                            </div>
                                        <div style={{ float: "left", padding: "5px", width: "4rem", display: "inline-block" }}>
                                            {/* <VirtualizedSelect
                                                options={this.state.version_id_res}
                                                onChange={(version_id_selected) => this.onVersionIdChange(version_id_selected)}
                                                value={this.state.version_id_selected}
                                            /> */}              
                                            <input type="text" id = "benchname" placeholder=" Bench Name " style={{ width: "6rem" }} onChange={(e) => this.onBenchChangeHandler(e)}/>
                                        </div>
                                    </div>
                                    <div style={{ width: "14rem", padding: "5px", display: "inline-block" }}>
                                        <div style={{ float: "left", padding: "5px", display: "inline-block", color: "#FFFFFF", fontWeight: "bold" }}>
                                            Cad Id :
                                            </div>
                                        <div style={{ float: "left", padding: "5px", width: "4rem", display: "inline-block" }}>
                                            {/* <VirtualizedSelect
                                                options={this.state.version_id_res}
                                                onChange={(version_id_selected) => this.onVersionIdChange(version_id_selected)}
                                                value={this.state.version_id_selected}
                                            /> */}
                                            <input type="text" id = "cadid" placeholder=" Cad Id " style={{ width: "6rem" }} onChange={(e) => this.OnCadIdChangeHandler(e)}/>
                                        </div>
                                    </div>
                                    <div style={{ width: "14rem", padding: "5px", display: "inline-block" }}>
                                        <div style={{ float: "left", padding: "5px", display: "inline-block", color: "#FFFFFF", fontWeight: "bold" }}>
                                            Status :
                                            </div>
                                        <div style={{ float: "left", padding: "5px", width: "4rem", display: "inline-block" }}>
                                            {/* <VirtualizedSelect
                                                options={this.state.version_id_res}
                                                onChange={(version_id_selected) => this.onVersionIdChange(version_id_selected)}
                                                value={this.state.version_id_selected}
                                            /> */}
                                            <input type="text" id = "statusid" placeholder=" Status " style={{ width: "6rem" }} onChange={(e) => this.onStatusChangeHandler(e)}/>
                                        </div>
                                    </div>
                                    <div style={{float: "left", padding: "5px", display: "inline-block", width: "39rem" , color: "#FFFFFF",fontWeight: "bold"}} >
                                        <input type="checkbox" id="runIdCheck" name="vehicle1" value="Bike" defaultChecked={this.state.runIdNullFilterChecked} onChange={this.toggleRunIdNullFilter}></input>
                                        <label htmlFor="runIdCheck"> &nbsp;Display Valid Test Run ID</label>
                                    </div>
                                    </form>
                                </div>
                                
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <ButtonToolbar>
                            <button type="button" className="btn" style={{ cursor: "pointer", color: "#212121", backgroundColor: "#B0FF44" }}
                                onClick={() => this.onSearchFilter()}>
                                Search
                            </button>
                            <button type="button" className="btn" style={{ cursor: "pointer", color: "#212121", backgroundColor: "#B0FF44" ,marginLeft:"1rem"}}
                                onClick={(e)=>this.onResetFilter(e)}>
                                Clear All
                            </button>
                        </ButtonToolbar>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}
AdvanceSearchModalCloseLoopRevised.propTypes={
onSearchClick:PropTypes.string,
closeSearchModal:PropTypes.string,
}
AdvanceSearchModalCloseLoopRevised.defaultProps= {
onSearchClick:[],
closeSearchModal:[],
}

export default AdvanceSearchModalCloseLoopRevised
